import {InstagramService} from '../../../services/social/instagram.service';

class InstagramHandler {

  constructor(
    private instagramService: InstagramService,
  ) {
  }
}
export default InstagramHandler;
